module.exports = __webpack_public_path__ + "img/light.92c1f6d3.png";